module.exports = __webpack_public_path__ + "img/virgool.1d9137f3.svg";